import React, { useEffect, useContext } from 'react';
import { RootStoreContext } from '../../../stores/rootStore';
import TermsAndConditionsUserForm from '../../organisms/TermsAndConditionsUserForm';
import { history } from '../../..';
import { observer } from 'mobx-react-lite';

const Setup: React.FC = observer(() => {

    const rootStore = useContext(RootStoreContext);
    const { getPractice } = rootStore.practiceStore;

    const handleSubmit = () => {
        history.push('/projects')
    }

    useEffect(() => {
        let isLoading = true;
        getPractice().finally(() => {
            // isLoading(true);
        })
        return () => {
            isLoading = false;   // clean up function
        };
    }, []);

    return (
        <TermsAndConditionsUserForm handleSubmit={handleSubmit}/>
    )

})

export default Setup;